const styles = theme => ({
  container: {
    width: '100%',
    padding: '120px 0',
    display: 'flex',
    justifyContent: 'center',
  },

  mainContent: {
    width: '100%',
    maxWidth: '800px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
  },

  header: {
    textAlign: 'center',
  },

  headerTitle: {
    color: 'var(--mcg-dark, #002E47)',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal',
  },

  optionsGrid: {
    display: 'flex',
    gap: '20px',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },

  optionWrapper: {
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    flex: 1,
    maxWidth: '280px',
    minWidth: '250px',
  },

  optionCard: {
    borderRadius: '12px',
    border: '1px solid rgba(145, 158, 171, 0.32)',
    background: '#FFFFFF',
    padding: '20',
    transition: 'all 0.3s ease-in-out',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    minHeight: '160px',
    justifyContent: 'center',
    gap: '8px',
    maxWidth: '240px',
  },

  optionCardSelected: {
    background: 'linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)',
    border: '2px solid #2196F3',
    boxShadow: '0 4px 16px rgba(33, 150, 243, 0.2)',
    borderRadius: '12px',
  },

  optionCardHovered: {
    borderRadius: '12px',
    border: '1px solid var(--mcg-blue, #015FFB)',
    background: 'var(--mcg-lightblue, #E3F3FF)',
  },

  iconWrapper: {
    marginBottom: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  iconNormal: {
    color: '#666666',
    transition: 'color 0.3s ease-in-out',
  },

  iconSelected: {
    color: '#1976D2',
    transition: 'color 0.3s ease-in-out',
  },

  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },

  optionTitle: {
    color: '#002E47',
    textAlign: 'center',
    fontFamily: 'Be Vietnam',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '150%' /* 27px */,
  },

  optionDescription: {
    fontSize: '16px',
    fontWeight: '400',
    color: '#666666',
    margin: 0,
    lineHeight: '1.3',
  },

  // Responsive design
  '@media (max-width: 768px)': {
    container: {
      padding: '16px',
    },

    optionsGrid: {
      flexDirection: 'column',
      gap: '16px',
    },

    optionWrapper: {
      maxWidth: '100%',
      minWidth: 'auto',
    },

    headerTitle: {
      fontSize: '24px',
    },

    optionCard: {
      padding: '24px 20px',
      minHeight: '140px',
      maxWidth: '240px',
    },
  },
})

export default styles
